// Serviciul comun de feedback după mutație (docs/design/ui-kit.md → Feedback după mutație).
// O mutație reușită spune scurt ce s-a întâmplat, într-un singur snackbar global (`AppFeedbackHost`),
// cu aceeași durată peste tot. Eroarea rămâne inline în suprafața care a eșuat, nu aici.
import { reactive } from "vue";

export const MUTATION_FEEDBACK_TIMEOUT = 3500;
const TYPES = Object.freeze(["success", "info", "warning", "error"]);

let nextId = 1;

/** Starea partajată: `AppFeedbackHost` o afișează. Un mesaj nou îl înlocuiește pe cel curent. */
export const mutationFeedbackState = reactive({ open: false, id: 0, message: "", type: "success" });

export function notifyMutation(message, type = "success") {
  const text = String(message ?? "").trim();
  if (!text) return false;
  mutationFeedbackState.message = text;
  mutationFeedbackState.type = TYPES.includes(type) ? type : "success";
  mutationFeedbackState.id = nextId++;
  mutationFeedbackState.open = true;
  return true;
}

export function dismissMutationFeedback() {
  mutationFeedbackState.open = false;
}
